let msdkiOSHandler;

// let msdkiOSHandlerV3;

// function connectWebViewJavascriptBridge(callback) {
//   if (window.WebViewJavascriptBridge) {
//     callback(WebViewJavascriptBridge);
//   } else {
//     document.addEventListener('WebViewJavascriptBridgeReady', () => {
//       callback(WebViewJavascriptBridge);
//     }, false);
//   }
// }

// function initGameInMsdkV3() {
//   console.log('init initGameInMsdkV3');
//   try {
//     connectWebViewJavascriptBridge((bridge) => {
//       bridge.init((message, responseCallback) => {
//         console.log('JS got a message', message);
//         const data = {
//           'Javascript Responds': 'Wee!',
//         };
//         console.log('JS responding with', data);
//         responseCallback(data);
//       });
//       bridge.registerHandler('msdkNativeCallback', (data, responseCallback) => {
//         msdkNativeCallback(data);
//         console.log('msdkNativeCallback', responseCallback, data);
//       });
//       msdkiOSHandlerV3 = bridge.callHandler;
//     });
//   } catch (error) {
//     console.error('initGameInMsdkV3', error);
//   }
// }

// 设置页面脚本
const setupWebViewJavascriptBridge = function (callback) {
  if (window.WebViewJavascriptBridge) {
    // eslint-disable-next-line no-undef
    return callback(WebViewJavascriptBridge);
  }

  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }

  window.WVJBCallbacks = [callback];
  const wvjbiFrame = document.createElement('iframe');
  wvjbiFrame.style.display = 'none';
  wvjbiFrame.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(wvjbiFrame);
  setTimeout(() => {
    document.documentElement.removeChild(wvjbiFrame);
  }, 0);
};

const initGameInMsdk = function () {
  console.log('init initGameInMsdk');
  try {
    setupWebViewJavascriptBridge((bridge) => {
      msdkiOSHandler = bridge.callHandler;
      bridge.registerHandler('MSDKJSHandler', (data, responseCallback) => {
        console.log('ObjC called MSDKJSHandler with', data, responseCallback);
        alert(data);
      });
      bridge.registerHandler('OnGetNetworkType', (data, responseCallback) => {
        console.log('ObjC called OnGetNetworkType with', data, responseCallback);
        // eslint-disable-next-line no-undef
        OnGetNetworkType(data);
      });
      console.log('MSDKReady');
    });
  } catch (error) {
    console.error('initGameInMsdk', error);
  }
};

// ---MSDK 游戏测需要根据自己的条件进行判断是否ios环境---
function isiOS() {
  return (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream;
}

// 初始化游戏内关闭页面方法
// if (navigator.userAgent.indexOf('MSDK') > -1) {

// msdkV3
if (/msdkEncodeParam/.test(location.search)) {
  console.log('initMSDK v3');
  // initGameInMsdkV3();
  // mskdV5
} else if (new RegExp('itopencodeparam').test(location.search)) {
  console.log('initMSDK v5');
  initGameInMsdk();
}
// }

export const gameMsdk = {

  // 游戏内msdk函数初始化
  msdkCall(data) {
    if (isiOS()) {
      msdkiOSHandler('MSDKCall', data, null);
    } else {
      if (data.indexOf('nativeCallJS') > -1) {
        console.log(`msdkCall invoked nativeCallJS : ${data}`);
        alert(data);
      } else {
        console.log(`msdkCall invoked : ${data}`);
        prompt(data);
      }
    }
  },

  msdkCloseWebview() {
    window?.msdkCloseWebview();
  },

};

export default gameMsdk;
